export default "__VITE_ASSET__B4l4dDnL__"